'use client'

import React from 'react'
import styles from './styles.module.css'
import { processStrapiTextTags } from '@/components/StrapiContentRenderer'
import { convertRichTextToHTML } from '@/components/StrapiContentRenderer'

interface TwoColumnsParagraphsTitlesItem {
  id?: number
  title?: string | any
  description?: string | any
}

interface TwoColumnsParagraphsTitlesItemsData {
  two_columns_paragraphs_titles_items?: Array<TwoColumnsParagraphsTitlesItem>
}

interface TwoColumnsParagraphsTitlesItemsProps {
  data: TwoColumnsParagraphsTitlesItemsData
}

const processText = (text: string | any): string => {
  if (!text) return ''
  
  if (typeof text === 'string') {
    // Обрабатываем переносы строк: \n\n = новый абзац, \n = перенос
    let processed = text.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>')
    if (processed && !processed.startsWith('<p>')) {
      processed = `<p>${processed}</p>`
    }
    return processStrapiTextTags(processed)
  }
  
  if (Array.isArray(text)) {
    const html = convertRichTextToHTML(text)
    return processStrapiTextTags(html)
  }
  
  return processStrapiTextTags(String(text))
}

const TwoColumnsParagraphsTitlesItems: React.FC<TwoColumnsParagraphsTitlesItemsProps> = ({ data }) => {
  const items = data.two_columns_paragraphs_titles_items?.filter(
    item => item.title || item.description
  ) || []

  if (items.length === 0) {
    return null
  }

  return (
    <section className={styles.twoColumnsParagraphsTitlesItems}>
      {items.map((item, index) => {
        const title = processText(item.title)
        const description = processText(item.description)

        if (!title && !description) return null

        return (
          <div key={item.id || index} className={styles.column}>
            {title && (
              <h4 
                className={styles.title}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            )}
            {description && (
              <div 
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
          </div>
        )
      })}
    </section>
  )
}

TwoColumnsParagraphsTitlesItems.displayName = 'TwoColumnsParagraphsTitlesItems'

export default TwoColumnsParagraphsTitlesItems

